import * as React from "react";

import { ContextProps } from "./Dialog.types";

export const InnerContext = React.createContext<ContextProps | null>(null);
